import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Clock, Shield, Users, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/languagecontext';

export const WhyChooseUs = () => {
  const { t } = useLanguage();
  
  const features = [
    { icon: Award, title: t('whyChoose.feature1.title'), description: t('whyChoose.feature1.description') },
    { icon: Clock, title: t('whyChoose.feature2.title'), description: t('whyChoose.feature2.description') },
    { icon: Shield, title: t('whyChoose.feature3.title'), description: t('whyChoose.feature3.description') },
    { icon: Users, title: t('whyChoose.feature4.title'), description: t('whyChoose.feature4.description') }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/photo_5116493174661647891_y.jpg"
                alt="Professional concrete work"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-orange-500 text-white rounded-xl p-6 shadow-2xl">
              <div className="text-4xl font-bold mb-1">10+</div>
              <div className="text-sm font-medium">{t('whyChoose.feature1.title')}</div>
            </div>
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">{t('whyChoose.title')}</h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">{t('whyChoose.description')}</p>
            <div className="grid sm:grid-cols-2 gap-6 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 rounded-xl hover:bg-slate-50 transition-colors">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-orange-500" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/about" className="inline-flex items-center text-orange-500 hover:text-orange-600 font-semibold text-lg group">
              {t('whyChoose.learnMore')}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
